import { LayoutGridAuto } from 'breeze-intelligence-kit';
import { useEnrichmentCredits } from '../../EnrichmentCreditsProvider';
import { CreditTileOverage } from './CreditTileOverage';
import { CreditTileUsed } from './CreditTileUsed';
import { CreditTileAvailable } from './CreditTileAvailable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditTileModal = () => {
  const {
    availableCredits,
    hasLowCredits,
    isLoading,
    showOverage,
    totalOverage,
    totalUsage,
    usageLimit
  } = useEnrichmentCredits();
  if (showOverage) {
    return /*#__PURE__*/_jsxs(LayoutGridAuto, {
      alignItems: "stretch",
      autoRepeat: "auto-fit",
      gap: "space-sm",
      minWidth: "10rem",
      children: [/*#__PURE__*/_jsx(CreditTileUsed, {
        hasLowCredits: hasLowCredits,
        isLoading: isLoading,
        totalUsage: totalUsage,
        usageLimit: usageLimit
      }), /*#__PURE__*/_jsx(CreditTileOverage, {
        credits: totalOverage,
        hasLowCredits: hasLowCredits,
        isLoading: isLoading
      })]
    });
  }
  return /*#__PURE__*/_jsx(CreditTileAvailable, {
    credits: availableCredits,
    hasLowCredits: hasLowCredits,
    isLoading: isLoading
  });
};